export enum EventList {
    unauthenticated='unauthenticated'
}